module.exports = __webpack_public_path__ + "img/2.1df5d3df.png";